import type { PaginationCriteria } from '@openx/types/tableCriteria.ts';
import { useEffect } from 'react';

import type { FetchMore } from '../../types.ts';

type UsePrefetchProps = {
  pagination: PaginationCriteria | undefined;
  fetchMore: FetchMore;
};

export const usePrefetch = ({ pagination, fetchMore }: UsePrefetchProps) => {
  const count = pagination?.totalCount ?? 0;

  useEffect(() => {
    const fetchMoreJob = setTimeout(() => {
      const preloadOffset = (pagination?.pageSize ?? 1) * (pagination?.pageNumber ?? 1);
      if (preloadOffset < count) {
        fetchMore({
          variables: {
            offset: preloadOffset,
          },
        });
      }
    }, 500);

    return () => {
      clearTimeout(fetchMoreJob);
    };
  }, [pagination, count, fetchMore]);
};
